/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect} from 'react'
import {Outlet, Link} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../_dashboard/helpers'

const AuthLayout = () => {
  useEffect(() => {
    const root = document.getElementById('root')
    if (root) {
      root.style.height = '100%'
    }
    return () => {
      if (root) {
        root.style.height = 'auto'
      }
    }
  }, [])

  return (
    <div className='d-flex flex-column flex-lg-row flex-column-fluid h-100'>
      <div
        className='d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center order-1 order-lg-1 position-relative'
        style={{
          backgroundImage: `linear-gradient(155deg, rgba(0, 28, 61, 0.92) 0%, rgba(0, 52, 127, 0.88) 45%, rgba(1, 90, 160, 0.85) 100%), url(${toAbsoluteUrl('/media/misc/auth-bg.png')})`,
          backgroundColor: '#001c3d',
        }}
      >
        <div className='d-flex flex-column flex-center py-15 px-5 px-md-15 w-100'>
          <Link to='/' className='mb-8 text-decoration-none text-center'>
            {/* Original logo colors (no invert filter) */}
            <img
              alt='Touil Travel Tunisia'
              src={toAbsoluteUrl('/media/logos/logo-touil.svg')}
              className='mx-auto w-275px w-md-50 w-xl-350px mb-6'
            />
            <div className='text-white text-opacity-75 mt-2 fs-7 fw-semibold text-uppercase'>
              Backoffice
            </div>
          </Link>
        </div>
      </div>

      <div className='d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-2 bg-white'>
        <div className='d-flex flex-center flex-column flex-lg-row-fluid'>
          <div className='w-lg-500px p-10'>
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  )
}

export {AuthLayout}
